import {useState} from "react";
import submitForm from "../../models/forms";


export default function ContactUsComponent(props) {

    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [website, setWebsite] = useState('');
    const [message, setMessage] = useState('');
    const [didSubmit, setDidSubmit] = useState(false);

    return (
        <div>
            {headerView()}
            {mainView()}
        </div>
    )

    function headerView() {
        return (
            <main className="" style={{marginBottom: "0px", paddingBottom: "0px"}}>
                <section className="container container-wide container-single">
                    <section id="" className="ns-bio-hero alignfull" style={{marginBottom: "0px", paddingBottom: "0px"}}>
                        <div className="container ns-bio-hero__info">
                            <div className="ns-bio-hero__info__content">
                                <h1>GET WHAT YOU NEED, <i>NOW!</i></h1>
                            </div>
                        </div>
                        <div className="ns-bio-hero__image">
                            <figure>
                                <img decoding="async"
                                     src="https://images.pexels.com/photos/8279049/pexels-photo-8279049.jpeg"
                                     alt="How to build your SEO Today"/>
                            </figure>
                        </div>
                    </section>
                </section>
            </main>
        )
    }

    function mainView() {

        return (
            <div className="relative isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
                <svg
                    aria-hidden="true"
                    className="absolute inset-0 -z-10 size-full mask-[radial-gradient(100%_100%_at_top_right,white,transparent)] stroke-gray-200"
                >
                    <defs>
                        <pattern
                            x="50%"
                            y={-64}
                            id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                            width={200}
                            height={200}
                            patternUnits="userSpaceOnUse"
                        >
                            <path d="M100 200V.5M.5 .5H200" fill="none"/>
                        </pattern>
                    </defs>
                    <svg x="50%" y={-64} className="overflow-visible fill-gray-50">
                        <path
                            d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M299.5 800h201v201h-201Z"
                            strokeWidth={0}
                        />
                    </svg>
                    <rect fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)" width="100%" height="100%" strokeWidth={0}/>
                </svg>
                <div className="mx-auto max-w-xl lg:max-w-4xl">
                    <h2 className="text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl">
                        Let’s talk about your project.
                    </h2>
                    <p className="mt-2 text-lg/8 text-gray-600">
                        We help companies and individuals build out their brand presence.
                    </p>
                    <div className="mt-16 flex flex-col gap-16 sm:gap-y-20 lg:flex-row">
                        <div className="lg:flex-auto">
                            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                                <div>
                                    <label htmlFor="first-name" className="block text-sm/6 font-semibold text-gray-900">
                                        Full name
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            id="full-name"
                                            name="full-name"
                                            type="text"
                                            autoComplete="name"
                                            disabled={didSubmit}
                                            value={fullName}
                                            onChange={(e) => {setFullName(e.target.value)}}
                                            className="block ring w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 backdrop-blur-sm placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="last-name" className="block text-sm/6 font-semibold text-gray-900">
                                        Contact email
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            disabled={didSubmit}
                                            value={email}
                                            onChange={(e) => {setEmail(e.target.value)}}
                                            className="block ring w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 backdrop-blur-sm placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="budget" className="block text-sm/6 font-semibold text-gray-900">
                                        Phone number
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            id="tel"
                                            name="tel"
                                            type="text"
                                            autoComplete="tel"
                                            disabled={didSubmit}
                                            value={phoneNumber}
                                            onChange={(e) => {setPhoneNumber(e.target.value)}}
                                            className="block ring w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 backdrop-blur-sm placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="website" className="block text-sm/6 font-semibold text-gray-900">
                                        Website
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            id="website"
                                            name="website"
                                            type="url"
                                            disabled={didSubmit}
                                            value={website}
                                            onChange={(e) => {setWebsite(e.target.value)}}
                                            className="block ring w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 backdrop-blur-sm placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                        />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="message" className="block text-sm/6 font-semibold text-gray-900">
                                        Message
                                    </label>
                                    <div className="mt-2.5">
                                  <textarea
                                      id="message"
                                      name="message"
                                      rows={4}
                                      className="block ring w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 backdrop-blur-sm placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                      defaultValue={''}
                                      disabled={didSubmit}
                                      value={message}
                                      onChange={(e) => {setMessage(e.target.value)}}
                                  />
                                    </div>
                                </div>
                            </div>
                            <div className="mt-10">
                                <button
                                    disabled={didSubmit}
                                    className={`${didSubmit ? "bg-gray-600" : "bg-indigo-600 hover:bg-indigo-500"} block w-full rounded-md px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                                    onClick={() => {
                                        submitForm("contact_us", {
                                            full_name: fullName,
                                            email: email,
                                            website: website,
                                            phone_number: phoneNumber,
                                            message: message,
                                        })
                                        setDidSubmit(true)
                                    }}
                                >
                                    { didSubmit ? "Submitted!" : "Let’s talk" }
                                </button>
                            </div>
                            <p className="mt-4 text-sm/6 text-gray-500">
                                By submitting this form, I agree to the{' '}
                                <a target="_blank" href="/privacy-policy" className="font-semibold whitespace-nowrap text-indigo-600">
                                    privacy policy
                                </a>
                                .
                            </p>
                        </div>
                        {/*<div className="lg:mt-6 lg:w-80 lg:flex-none">*/}
                        {/*    <img*/}
                        {/*        alt=""*/}
                        {/*        src="https://tailwindcss.com/plus-assets/img/logos/workcation-logo-indigo-600.svg"*/}
                        {/*        className="h-12 w-auto"*/}
                        {/*    />*/}
                        {/*    <figure className="mt-10">*/}
                        {/*        <blockquote className="text-lg/8 font-semibold text-gray-900">*/}
                        {/*            <p>*/}
                        {/*                “Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo expedita voluptas*/}
                        {/*                culpa sapiente alias*/}
                        {/*                molestiae. Numquam corrupti in laborum sed rerum et corporis.”*/}
                        {/*            </p>*/}
                        {/*        </blockquote>*/}
                        {/*        <figcaption className="mt-10 flex gap-x-6">*/}
                        {/*            <img*/}
                        {/*                alt=""*/}
                        {/*                src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=96&h=96&q=80"*/}
                        {/*                className="size-12 flex-none rounded-full bg-gray-50"*/}
                        {/*            />*/}
                        {/*            <div>*/}
                        {/*                <div className="text-base font-semibold text-gray-900">Brenna Goyette</div>*/}
                        {/*                <div className="text-sm/6 text-gray-600">CEO of Workcation</div>*/}
                        {/*            </div>*/}
                        {/*        </figcaption>*/}
                        {/*    </figure>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        )
    }
}


